import { NgModule } from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from "@angular/router";

import { PerfomanceComponent } from './perfomance/perfomance.component';
import {ApiService} from "./api.service";
import {ViewModule} from "../views/view.module";

@NgModule({
  declarations: [ PerfomanceComponent],
  imports: [
	  ViewModule,
	  HttpClientModule,
	  RouterModule
  ],
	providers: [
		ApiService
	]
})
export class ApiModule { }
